


export enum EventActiveMode {
  Incomplete = -1,
  Inactive = 0,
  Active = 1,
}
